export default "__VITE_ASSET__CbvlcO3c__"